'use client';

import type { ReactNode } from 'react';
import { TransitionProvider } from '@/contexts/TransitionContext';
import SwarmTransition from './SwarmTransition';

export default function TransitionShell({ children }: { children: ReactNode }) {
  return (
    <TransitionProvider>
      <div className="flex-1 min-h-0 relative">
        {children}
        <SwarmTransition />
      </div>
    </TransitionProvider>
  );
}
